// removed by extract-text-webpack-plugin
module.exports = {"root":"_3LgZspL"};


/*****************
 ** WEBPACK FOOTER
 ** ./app/components/HomePage/components/Dashboard/Dashboard.less
 ** module id = 763
 ** module chunks = 0
 **/